// Portfolio content.

export const identity = {
  name: "Karan Sahu",
  role: "Product Lead | AI Engineer",
  company: "Prefiler Labs",
  location: "New Delhi, India",
  years: "8+",
  email: "cgkaransahu@gmail.com",
  prefilterEmail: "karan.sahu@prefiler.com",
  links: {
    portfolio: "https://karansahu.pro",
    linkedin: "https://linkedin.com/in/karansahu1",
    github: "https://github.com/GameDevKaran",
    aiEngineering: "https://karansahu.pro/ai-engineering",
    prefilter: "https://prefiler.com",
  },
};

export const experience = [
  {
    title: "AI & Quant Automation Engineer",
    company: "BLACK INK DEVELOPMENT LLC",
    type: "Self-employed",
    dates: "Nov 2025 – Aug 2026",
    location: "United States",
    workplace: "Remote",
    current: false,
    bullets: [
      "Built a private executive assistant / operations platform (Janice) for a US business.",
      "Deep Microsoft 365 integration — Outlook, Calendar, Contacts, OneDrive, Word, Excel, Teams — via Microsoft Graph with MSAL delegated authentication.",
      "FastAPI, React, TypeScript, SQLite, Docker, Windows 11, Ollama local LLM reasoning, server-side Graph tokens, owner locking, rate limiting, Tailscale.",
      "Research workflows, document preparation, email drafting, meeting packs and action tracking.",
    ],
  },
  {
    title: "Head of Technology",
    company: "Rosato Ventures",
    type: "Full-time",
    dates: "Jun 2022 – Nov 2025",
    location: "Dubai, United Arab Emirates",
    workplace: null,
    current: false,
    bullets: [
      "Led technical due diligence and evaluation of early-stage startups at Rosato.vc, a venture firm focused on blockchain, trading, and digital infrastructure.",
      "Provided in-depth assessments of product architectures, scalability, code quality, and infrastructure of prospective portfolio companies.",
      "Specialized in verifying the technical viability of quantitative trading platforms — strategy logic, automation reliability, and system architecture.",
      "Developed and delivered two in-house venture-backed products: Argha.ai (decentralized NFT minting and asset registry) and MudraQuant.com (automated crypto trading and arbitrage system).",
      "Drove both products from concept to completion — planning, architecture, development, and final transfer of operational control to Rosato.vc.",
    ],
  },
  {
    title: "Chief Technology Officer",
    company: "Comely Enterprises",
    type: "Full-time",
    dates: "May 2021 – Jun 2022",
    location: null,
    workplace: "On-site",
    current: false,
    bullets: [
      "Defined and led technology vision for Unity-based gaming products, Web2 platforms and blockchain-integrated solutions.",
      "Architecture, development and deployment of Unity games across mobile, web and real-money gaming platforms.",
      "Managed and mentored cross-functional teams of developers, artists and designers.",
      "Blockchain integrations including smart contracts, NFTs and decentralized payments; coding standards, optimisation strategies, CI/CD practices, product vision, monetisation and technology roadmaps across Web3 and XR.",
    ],
  },
  {
    title: "Game & AR/VR Simulations Developer",
    company: "NIIT Limited",
    type: "Full-time",
    dates: "Jan 2020 – May 2021",
    location: "Gurugram, Haryana, India",
    workplace: null,
    current: false,
    bullets: [
      "Designed and developed VR and AR simulations for training in manufacturing, construction, and logistics industries.",
      "Built immersive environments replicating real-world processes and safety protocols.",
      "Delivered cross-platform solutions compatible with Oculus, HTC Vive, ARKit, and ARCore.",
      "Worked closely with instructional designers and industry experts to translate complex procedures into interactive simulations.",
    ],
  },
  {
    title: "Game Developer",
    company: "Comely Enterprises",
    type: "Full-time",
    dates: "Aug 2017 – Jan 2020",
    location: "India",
    workplace: "Hybrid",
    current: false,
    bullets: [
      "Unity-based mobile games: gameplay systems, UI/UX and mobile performance.",
      "In-app purchases, payment gateways, wallet systems and analytics.",
      "Backend API development contribution, database management and cloud deployment workflows.",
      "Collaboration with artists and designers through production and store releases.",
    ],
  },
];

export const certifications = [
  { name: "Google AI", issuer: "Google", issued: "Sep 2026", id: "IXK60WWC6AU5", url: "https://www.coursera.org/account/accomplishments/specialization/IXK60WWC6AU5" },
  { name: "AI for App Deployment", issuer: "Google", issued: "Sep 2026", id: "HSQI00EY4DTL", url: "https://www.coursera.org/account/accomplishments/records/HSQI00EY4DTL" },
  { name: "AI for App Building", issuer: "Google", issued: "Sep 2026", id: "BYWK8JSD64SY", url: "https://www.coursera.org/account/accomplishments/records/BYWK8JSD64SY" },
  { name: "AI for Data Analysis", issuer: "Google", issued: "Sep 2026", id: "T1FZPOBRE1HF", url: "https://www.coursera.org/account/accomplishments/records/T1FZPOBRE1HF" },
  { name: "AI for Content Creation", issuer: "Google", issued: "Sep 2026", id: "GUDXPH0TMIYA", url: "https://www.coursera.org/account/accomplishments/records/GUDXPH0TMIYA" },
  { name: "AI for Writing and Communicating", issuer: "Google", issued: "Sep 2026", id: "KWH07X8YYR3I", url: "https://www.coursera.org/account/accomplishments/records/KWH07X8YYR3I" },
  { name: "AI for Research and Insights", issuer: "Google", issued: "Aug 2026", id: "5Y0SLYF4X52H", url: "https://www.coursera.org/account/accomplishments/records/5Y0SLYF4X52H" },
  { name: "AI for Brainstorming and Planning", issuer: "Google", issued: "Aug 2026", id: "XBNEHCQTO6UL", url: "https://www.coursera.org/account/accomplishments/records/XBNEHCQTO6UL" },
  { name: "AI Fundamentals", issuer: "Google", issued: "Aug 2026", id: "P4PAJ0CDLVBD", url: "https://www.coursera.org/account/accomplishments/records/P4PAJ0CDLVBD" },
  { name: "Learn Advanced AI for Games with Behaviour Trees", issuer: "Udemy", issued: "Jan 2023", id: "UC-aaf9768e-297c-468d-8d11-54c3a4a72bc6", url: "https://www.udemy.com/certificate/UC-aaf9768e-297c-468d-8d11-54c3a4a72bc6/" },
];

export const recommendations = [
  {
    quote: "Karan is a total package when it comes to a developer, I loved his attention to details. We were lucky to have such a young talent to work with us on some amazing games. Just wish him all the very best for his bright future ahead.",
    author: "Hardeep Singh Mehta",
    role: "Fractional CTO & Product Engineering Leader",
    relationship: "Managed Karan directly",
    date: "January 24, 2022",
  },
  {
    quote: "karan is one of the youngest talent I have seen out there, there is a difference between working for ethics and working for passion and karan certainly works for the passion. He has an overwhelming grasping power aswell as great knowledge in developing games with Unity",
    author: "Aditya .S",
    role: "Product Design Lead",
    relationship: null,
    date: "December 6, 2021",
  },
  {
    quote: "Karan is a great entrepreneur in making and I have gone through his new product Prefiler which is very informative and will surely do good. Congratulations Karan.",
    author: "Sonali Malhotra",
    role: "Senior Marketing Executive",
    relationship: "Karan was Sonali's client",
    date: "March 24, 2026",
  },
  {
    quote: "Karan belongs to the clan of emerging entrepreneurs who if guided well, can create a change in the market. As someone who believes in emerging talent, Karan comes as an individual who is open to learning and sharing besides making one aware of his own perspective. 1 guy who holds the value of integrity, empathy and effective communication - the basis of leadership. Congratulations on your product Prefiler, Karan and wishing you all the great luck in the future ahead.",
    author: "Sourish Baruah",
    role: "HR & Administration Officer / Counselling Psychologist",
    relationship: "Karan was Sourish's client",
    date: "March 23, 2026",
  },
];

export const projects = [
  {
    name: "Prefiler",
    tagline: "Deterministic financial pre-filing review",
    description:
      "Financial/accounting pre-filing review platform: structured financial-data and document ingestion, deterministic validations, reconciliation and evidence-linked findings. Jurisdiction-aware rule execution with rule/version management, report generation and full auditability — controlled, bounded AI. Live in India; UAE targeted.",
    tags: ["GCP", "Cloud Run", "Cloud SQL / PostgreSQL", "Firebase Auth", "Cloud Storage", "Vertex AI", "Deterministic Validation", "Ledger Ingestion"],
    links: [
      { label: "prefiler.com", url: "https://prefiler.com" },
      { label: "Validation", url: "https://prefiler.com/validation" },
      { label: "Engine Capabilities", url: "https://prefiler.com/engine-capabilities" },
      { label: "Product Tour", url: "https://prefiler.com/product-tour" },
      { label: "API Contracts", url: "https://prefiler.com/api-contracts" },
      { label: "Jurisdictions", url: "https://prefiler.com/jurisdictions" },
      { label: "Enterprise", url: "https://prefiler.com/enterprise" },
    ],
    featured: true,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkYXJrJTIwZGFzaGJvYXJkJTIwVUl8ZW58MHx8fHwxNzg5MDgzNDgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Janice",
    tagline: "Local-first executive operations system",
    description:
      "Private executive assistant / operations platform for a US business (Black Ink Development). Microsoft 365 operations across Outlook, Calendar, Contacts, OneDrive, Word, Excel and Teams via Microsoft Graph with MSAL delegated authentication. Research, document preparation, email drafts, meeting packs and action tracking — with local LLM reasoning.",
    tags: ["FastAPI", "React 18", "TypeScript", "SQLite", "Docker", "Ollama", "Microsoft Graph", "MSAL", "Tailscale", "Windows 11"],
    links: [],
    status: "Private client system — no public repository",
    featured: true,
  },
  {
    name: "AudienceGraph",
    tagline: "Streaming audience operations investigation",
    description:
      "Investigates whether a completion drop is a content issue, an audience shift, or a viewing/playback problem. Discovers schema, establishes a baseline, runs cohort tests, checks competing explanations and returns an evidence-linked decision brief with JSON export. Runtime analytical queries go through the official mcp-clickhouse server; an explicit arithmetic consistency check guards the headline.",
    tags: ["Gemini", "Google Cloud", "Vertex AI", "ClickHouse", "mcp-clickhouse", "Python", "React", "Cloud Run"],
    links: [
      { label: "Live App", url: "https://audiencegraph-web-kc4mxxrtbq-uc.a.run.app" },
      { label: "GitHub", url: "https://github.com/GameDevKaran/audiencegraph" },
    ],
    image: "https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBkYXJrJTIwZGFzaGJvYXJkJTIwVUl8ZW58MHx8fHwxNzg5MDgzNDgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Greenlight AI",
    tagline: "Evidence-backed studio decision intelligence",
    description:
      "Helps producers and development executives assess whether to greenlight a film project. Combines creative material with current market research, separates sourced evidence from model interpretation, and produces an auditable decision brief with a concrete action plan. It does not forecast revenue or replace executive judgment.",
    tags: ["React", "TypeScript", "Vite", "FastAPI", "Gemini", "Vertex AI", "Parallel Search", "SQLite", "Deterministic Scoring"],
    links: [
      { label: "Live App", url: "https://greenlight-kc4mxxrtbq-uc.a.run.app" },
      { label: "GitHub", url: "https://github.com/GameDevKaran/greenlight-ai-agentic-cinema" },
    ],
    image: "https://images.unsplash.com/photo-1619262105903-c65a6396c72f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXJrJTIwZGFzaGJvYXJkJTIwVUl8ZW58MHx8fHwxNzg5MDgzNDgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "ClauseRunner",
    tagline: "Post-signature contract operations agent",
    description:
      "Turns signed vendor agreements into persistent operational obligations. Monitors compliance evidence, runs autonomous investigations via Amazon Bedrock through Strands, maps violations to remedies and prepares claim packages under strict deterministic code rules and human-in-the-loop approval.",
    tags: ["FastAPI", "React / Vite", "Amazon Bedrock", "Strands", "SQLite / DynamoDB", "Audit Ledger", "Human-in-the-Loop"],
    links: [{ label: "GitHub", url: "https://github.com/GameDevKaran/clauserunner" }],
  },
  {
    name: "UnityCopilot",
    tagline: "AI-powered Unity development assistant",
    description:
      "Integrates directly into the Unity Editor — generate scripts, build scenes and audit projects using natural language prompts. Built with Unity 2023 LTS + UIToolkit.",
    tags: ["Unity 2023 LTS", "UIToolkit", "C#", "Editor Tooling", "AI Assistance"],
    links: [{ label: "GitHub", url: "https://github.com/GameDevKaran/UnityCopilot" }],
  },
  {
    name: "Storyworld Live",
    tagline: "The Last Broadcast — agentic interactive mystery",
    description:
      "A fan-facing interactive mystery about a city, a suppressed recording, and the person you choose to save. Four decisions change faction influence, relationships, character memories, available routes and the ending. Original narrative and vector artwork. Playable local rehearsal build; live Gemini mode in progress.",
    tags: ["Python", "FastAPI", "Gemini", "Vertex AI", "SQLite / PostgreSQL", "Interactive Narrative"],
    links: [{ label: "GitHub", url: "https://github.com/GameDevKaran/storyworld-live-agentic-cinema" }],
    status: "Playable rehearsal — live build in progress",
  },
];

export const legacyProjects = [
  { name: "MudraQuant", description: "Automated crypto trading and arbitrage system — quantitative strategy logic, realtime market feeds, backtesting, exchange integrations and automated execution.", context: "Rosato Ventures in-house product" },
  { name: "Argha.ai", description: "Decentralized NFT minting and asset registry platform.", context: "Rosato Ventures in-house product", tags: ["Solidity", "NFTs", "IPFS", "The Graph"] },
  { name: "Nexoul", description: "Multi-tenant whitelabel delivery platform.", context: "Product engineering" },
  { name: "Web3 Gaming Ecosystem", description: "Gaming products with Web3 / blockchain integration — Unity-based product engineering.", context: "Comely Enterprises era" },
];

export const githubRepos = [
  { name: "clauserunner", language: "Python", url: "https://github.com/GameDevKaran/clauserunner" },
  { name: "audiencegraph", language: "Python", url: "https://github.com/GameDevKaran/audiencegraph" },
  { name: "greenlight-ai-agentic-cinema", language: "Python", url: "https://github.com/GameDevKaran/greenlight-ai-agentic-cinema" },
  { name: "storyworld-live-agentic-cinema", language: "Python", url: "https://github.com/GameDevKaran/storyworld-live-agentic-cinema" },
  { name: "card-activity", language: "TypeScript", url: "https://github.com/GameDevKaran/card-activity" },
  { name: "my-project", language: "Python", url: "https://github.com/GameDevKaran/my-project" },
  { name: "UnityCopilot", language: "Unity / C#", url: "https://github.com/GameDevKaran/UnityCopilot" },
  { name: "MirrorMultiplayerPOC", language: "C#", url: "https://github.com/GameDevKaran/MirrorMultiplayerPOC" },
];

export const skillGroups = [
  { name: "AI & Agentic Systems", skills: ["LLM Applications", "Agentic Workflows", "Tool Calling", "RAG & Retrieval", "Vector Search", "Local LLMs (Ollama)", "Gemini / Vertex AI", "Structured Outputs", "Human-in-the-Loop", "Deterministic + AI Systems", "Bounded AI"] },
  { name: "Languages", skills: ["Python", "TypeScript", "JavaScript", "C#", "Solidity", "SQL"] },
  { name: "Backend & APIs", skills: ["FastAPI", "Node.js", "REST APIs", "WebSockets", "Webhooks", "API Integrations", "OAuth / MSAL", "Authentication & Authorization"] },
  { name: "Data", skills: ["PostgreSQL", "Cloud SQL", "SQLite", "Redis", "MongoDB", "Firebase", "ClickHouse", "Structured Financial Data", "Ledger Data"] },
  { name: "Cloud & Infrastructure", skills: ["Google Cloud Platform", "Cloud Run", "Cloud SQL", "Cloud Storage", "Firebase", "AWS", "Docker", "Nginx", "CI/CD", "Windows Deployment", "Tailscale"] },
  { name: "Microsoft 365", skills: ["Microsoft Graph", "MSAL", "Outlook", "Calendar", "Contacts", "OneDrive", "Word", "Excel", "Teams"] },
  { name: "Quant & Finance", skills: ["Quantitative Trading", "Crypto Arbitrage", "Realtime Market Data", "Trading Automation", "Backtesting", "Broker / Exchange Integrations", "Reconciliation", "Deterministic Financial Validation", "Accounting Rules"] },
  { name: "Unity / XR / Interactive", skills: ["Unity", "Gameplay Systems", "VR / AR / XR", "Oculus", "HTC Vive", "ARKit", "ARCore", "Mobile Optimisation", "Multiplayer Concepts", "In-App Purchases", "Payment Gateways", "Wallet Systems"] },
  { name: "Blockchain", skills: ["Solidity", "Smart Contracts", "NFTs", "IPFS", "The Graph", "Blockchain Integrations"] },
];

export const marqueeItems = [
  "AGENTIC SYSTEMS",
  "DETERMINISTIC AI",
  "PRODUCT ENGINEERING",
  "FINTECH INFRASTRUCTURE",
  "QUANT AUTOMATION",
  "UNITY & XR",
  "WEB3",
  "MICROSOFT 365",
  "EVIDENCE-LINKED DECISIONS",
  "HUMAN-IN-THE-LOOP",
];
